module.exports = __webpack_public_path__ + "img/mx.216d2ed.svg";